
import React from 'react'
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';

const NotFound = (props) => {

    let history = useHistory();

    const redireccionar = () => {

        history.push('/');


    }



    return (
        <>
            <div className='card'>
                <h5 className="text-center">404</h5>
                <h5 className="text-center">Página no encontrada.</h5>
                <form onSubmit={redireccionar}>
                    <div className="flex justify-content-center flex-wrap">
                        <Button label="Redireccionar" type="submit" className="p-button-sm" />
                    </div>
                </form>
            </div>
        </>
    );

}

export default NotFound;